<div class="full-screen overflow-hidden">
    <div class="d-flex flex-grow-1">
    </div>
</div>